import { SET_PROFILE, CLEAR_PROFILE, SetProfileAction } from '../action/profile'

type State = {
    loginProfile: LoginProfileType
    permissions: string[]
    isLoggedIn: boolean
}

const initializeState = {
    loginProfile: {
        fullname: '',
        email: '',
        groupName: '',
    },
    permissions: [],
    isLoggedIn: false,
} as State

const profileReducer = (state = initializeState, action: SetProfileAction): State => {
    switch (action.type) {
        case SET_PROFILE: {
            return {
                ...state,
                ...action.profile,
                isLoggedIn: true,
            }
        }

        case CLEAR_PROFILE: {
            return {
                ...initializeState,
                isLoggedIn: false,
            }
        }

        default:
            return state
    }
}

export default profileReducer
